import englishMessages from 'ra-language-english'
import { TranslationMessages } from 'react-admin'

const customEnglishMessages: TranslationMessages = {
  ...englishMessages,
  ra: {
    ...englishMessages.ra,
    action: {
      ...englishMessages.ra?.action,
      clear: 'Clear',
      reset: 'Reset',
    },
  },
  pos: {
    app_title: 'Adapet Vet Portal',
    login: {
      title: 'Sign in',
      subtitle: 'Adapet Medical vet portal',
      forgot_password: 'Forgot your password?',
      no_account: "Don't have an account?",
      sign_up: 'Sign up',
      or: 'or',
      continue_microsoft: 'Continue with Microsoft',
    },
    shared_with_me: {
      load_failed: 'Failed to load shared data. Please try again later.',
      empty_title: 'No patients shared with you yet',
      empty_subtitle:
        'When another veterinarian shares a patient case with you, it will appear here.',
      shared_by: 'Shared by %{name}',
      all_pets: 'All Pets',
      specific_pets: '%{count} Specific Pet |||| %{count} Specific Pets',
      you_can: 'You can: %{permissions}',
      shared_at: 'Shared: %{date}',
      expires_at: 'Expires: %{date}',
      shared_pets_label: 'Shared Pets:',
      view_pet: 'View Pet',
      pet_meta: '%{species} • Client: %{owner}',
      all_pets_message:
        "You have access to all pets owned by %{name}'s clients. Shared pets will appear in your regular pet lists with a shared indicator.",
      permissions: {
        view_metrics: 'View Metrics',
        view_emrs: 'View EMRs',
        add_activities: 'Add Activities',
        add_emr_notes: 'Add Notes',
      },
    },
    consent: {
      loading: 'Loading consent requests...',
      title: 'Group Membership Requests',
      title_with_count: 'Group Membership Requests (%{count})',
      no_pending: 'You have no pending group membership requests.',
      pending_warning: 'You have pending group membership requests that require your consent.',
      pending_chip: 'Pending',
      accept: 'Accept',
      decline: 'Decline',
      cancel: 'Cancel',
      invited_by: 'Invited by: %{name} (%{email})',
      invited_on: 'Invited on: %{date}',
      accept_dialog_title: 'Accept Group Membership',
      decline_dialog_title: 'Decline Group Membership',
      accept_question: 'Do you want to join the "%{group}" group?',
      decline_question: 'Are you sure you want to decline the invitation to join "%{group}"?',
      accept_warning:
        'By accepting, you will share patient data with authorized members of this group and gain access to their shared patients for collaborative monitoring.',
      notes_label: 'Notes (optional)',
      accept_notes_placeholder: 'Add any notes about joining this group...',
      decline_notes_placeholder: 'Add a reason for declining (optional)...',
      load_failed: 'Failed to load consent requests',
      retry: 'Try again',
      update_failed: 'Failed to update consent',
    },
    auth: {
      login: {
        email_not_verified:
          'Please verify your email before logging in. Check your inbox for the verification link.',
        invalid_credentials: 'Incorrect email or password.',
        account_locked:
          'Your account is temporarily locked due to too many failed attempts. Please try again later.',
        role_not_allowed:
          'This account does not have access to the vet portal. Pet owners should use the Adapet Medical mobile app.',
        generic_error: 'Login failed. Please try again.',
        oauth_failed:
          'Sign-in with that provider failed. Please try again or use email and password.',
        sso_failed:
          'Single sign-in could not be completed. Please start again from the original application, or sign in with your email and password.',
      },
      verify_email: {
        verifying_title: 'Verifying your email…',
        verifying_body: 'Please wait while we verify your email address.',
        success_title: 'Email verified',
        failed_title: 'Verification failed',
        success_message: 'Your email is verified. Redirecting you to sign in…',
        invalid_message: 'This verification link is invalid or has expired.',
        contact_support: 'Please contact support if you continue to experience issues.',
        go_to_login: 'Go to sign in',
      },
      forgot_password: {
        title: 'Forgot your password?',
        description: "Enter your email address and we'll send you a link to reset your password.",
        email_label: 'Email address',
        sending: 'Sending...',
        send_button: 'Send reset link',
        back_to_login: 'Back to sign in',
        success: 'Password reset email sent! Please check your inbox and follow the instructions.',
        email_required: 'Email is required',
        send_failed: 'Failed to send reset email',
        connection_error: 'Unable to connect to the server. Please try again later.',
      },
      reset_password: {
        title: 'Choose a new password',
        invalid_link_title: 'This link has expired',
        invalid_link_message: 'This password reset link is invalid or has expired.',
        request_new: 'Request a new link',
        new_password_label: 'New password',
        confirm_password_label: 'Confirm new password',
        resetting: 'Resetting...',
        reset_button: 'Reset password',
        success: 'Password successfully reset! Redirecting to login...',
        invalid_request: 'Invalid request. Please request a new password reset link.',
        reset_failed: 'Failed to reset password. The link may have expired.',
        network_error: 'Network error. Please try again.',
        password_required: 'Password is required',
        passwords_dont_match: 'Passwords do not match',
      },
    },
    search: 'Search',
    configuration: 'Configuration',
    language: 'Language',
    action: {},
    theme: {
      name: 'Theme',
      light: 'Light',
      dark: 'Dark',
    },
    dashboard: {
      title: 'Dashboard',
      welcome_subtitle: "Welcome back to Adapet Vet Portal. Here's what's happening today.",
      active_patient_context: 'Active Patient Context:',
      pet_id_label: 'Pet ID: %{id}',
      no_patient_selected: 'No patient selected. Select a patient to view monitoring data.',
      pets_section: 'Pets',
      devices_section: 'Devices',
      monthly_revenue: 'Monthly Monitoring Activity',
      month_history: '30-Day Monitoring Activity',
      new_orders: 'New Device Orders',
      pending_emrs: 'Pending EMRs',
      all_emrs: 'See all EMRs',
      new_customers: 'New Customers',
      all_customers: 'See all customers',
      pending_orders: 'Pending Device Orders',
      current_selected_pet: 'Current Selected Pet:',
      recently_updated: 'Recently Updated',
      generate_report: 'Generate Report',
      glucose_report: 'Glucose Report',
      glucose_trend: 'Glucose Trend',
      daily_tir: 'Daily TIR',
      daily_trends_and_activities: 'Daily Glucose Trends & Activities',
      simple_view: 'Simple View',
      full_report: 'Full Report',
      print_report: 'Print Report',
      no_data: 'N/A',
      activity_logs: 'Activity Logs',
      log_event_prompt: 'Click + Log Event to track insulin, food, or exercise activities',
      date_range_navigation: 'Date Range Navigation',
      clinical_notes: 'Clinical Notes',
      add_note_description: 'Add a note for this pet that will be included in the PDF report.',
      portal_view: 'Portal View',
      no_device_selected: 'No device available for this patient',
      no_devices: 'No devices found for this patient',
      search_pets: 'Search by client, patient name, patient ID, hospital, or device ID...',
      error_loading_data: 'Error loading data',
      no_data_available: 'No data available',
      order: {
        items: 'by %{customer_name}, one item |||| by %{customer_name}, %{nb_items} items',
      },
      welcome: {
        title: 'Welcome to Adapet Vet Portal',
        subtitle: 'Review patient monitoring data, glucose trends, and clinical activity.',
        ra_button: 'Open admin resources',
        demo_button: 'View product documentation',
      },
      clinical: {
        title: 'Dashboard',
        stat: {
          active_cgm_title: 'Active CGM Patients',
          active_cgm_subtitle: 'Currently using an active sensor',
          needs_review_title: 'Patients Needing Review',
          needs_review_subtitle: 'Glucose patterns or data gaps may require review',
          pending_confirmation_title: 'Pending Client Confirmation',
          pending_confirmation_subtitle: 'Accounts not yet confirmed',
          recent_alerts_title: 'Recent Glucose Alerts',
          recent_alerts_subtitle: 'Last 24 hours',
          follow_up_title: 'Follow-up Due Today',
          follow_up_subtitle: 'Scheduled for today',
        },
        active_cgm_patients: 'Active CGM Patients',
        search_placeholder: 'Search by patient, client, clinic, or device ID...',
        filter: 'Filter',
        hidden_patients: 'Hidden patients',
        todays_priority: "Today's Priority",
        no_priority: 'No high-priority patients right now.',
        pending_setup: 'Pending Setup / Confirmation',
        recent_activity: 'Recent Clinical Activity',
        no_recent_activity: 'No recent clinical activity.',
        loading: 'Loading clinical dashboard...',
        no_match: 'No patients match your search or filter.',
        no_email: 'No email',
        no_reading: 'No glucose reading',
        no_data: 'No data',
        review_trend: 'Review Trend',
        add_note: 'Add Note',
        resend_email: 'Resend Email',
        resend: 'Resend',
        view: 'View',
        edit: 'Edit',
        client_prefix: 'Client:',
        updated_prefix: 'Updated %{time}',
        species_fallback: 'Patient',
        // Relative timestamps on the patient list and the activity feed.
        time: {
          just_now: 'Just now',
          minutes_ago: '%{count} min ago',
          hours_ago: '%{count} hr ago',
          yesterday: 'Yesterday',
          days_ago: '%{count} days ago',
          recently: 'Recently',
        },
        pet_fallback: 'Pet #%{id}',
        breed_fallback: 'Mixed',
        table: {
          priority: 'Priority',
          patient: 'Patient',
          species_breed: 'Species / Breed',
          cgm_status: 'CGM Status',
          last_reading: 'Last Reading',
          alert_status: 'Alert Status',
          last_updated: 'Last Updated',
          action: 'Action',
          pet: 'Patient',
          client: 'Client',
          email: 'Email',
          status: 'Status',
          created: 'Created',
        },
        filters: {
          all: 'All Patients',
          'active-cgm': 'Active CGM',
          'needs-review': 'Needs Review',
          'recent-alerts': 'Recent Glucose Alerts',
          hypoglycemia: 'Hypoglycemia Alert',
          hyperglycemia: 'Hyperglycemia Alert',
          'pending-confirmation': 'Pending Confirmation',
          'follow-up': 'Follow-up Due',
          'my-patients': 'My Patients Only',
        },
        status: {
          Stable: 'Stable',
          'Needs Review': 'Needs Review',
          'Hypoglycemia Alert': 'Hypoglycemia Alert',
          'Hyperglycemia Alert': 'Hyperglycemia Alert',
          'Stale Reading': 'Stale Reading',
          'Data Gap': 'Data Gap',
          'Sensor Issue': 'Sensor Issue',
          'No Active Device': 'No Active Device',
          'Pending Client Confirmation': 'Pending Client Confirmation',
          'Follow-up Due': 'Follow-up Due',
        },
        // The dashboard's list fetches are SERVER-capped (ada-core
        // DEVICES_MAX_LIMIT / METRICS_MAX_LIMIT). Truncation used to be logged
        // only on the server, so a fleet-wide view silently rendered 1,000 of
        // 1,592 sensors and showed "No Device" for the rest.
        truncated: {
          title: 'This view is showing partial data',
          detail: 'Loaded %{loaded} of %{total} %{resource}.',
          pets: 'patients',
          devices: 'sensors',
          consequence:
            'Patients whose records fall outside this set can read "No Device" or show an out-of-date CGM status. Narrow the view to see them.',
        },
        load_error: {
          title: 'Some patient data could not be loaded',
          detail:
            'Statuses, readings and recent activity below may be incomplete — a patient can read "No Device" or show no glucose alert because of this. Reload the page to try again.',
        },
        cgm: {
          Active: 'Active',
          // Sensor stopped reporting for longer than INACTIVE_SENSOR_MS — off
          // the patient or session finished (Faithfull Friends, 2026-08-18).
          Inactive: 'Inactive',
          Pending: 'Pending',
          'No Device': 'No Device',
        },
        activity: {
          new_reading: 'New glucose reading received',
          pending_confirmation: 'Pending client confirmation',
          vet_note: 'Vet note added',
          hypoglycemia_detected: 'Low glucose alert recorded',
          hyperglycemia_detected: 'High glucose alert recorded',
          client_added: 'Client added %{type}',
        },
      },
    },
    whats_new: {
      title: "What's new",
      page_title: "What's new in VetPo",
      dialog_title: "What's new in VetPo",
      help_desc: 'What changed in recent portal updates, in plain language.',
      released_on: 'Released %{date}',
      got_it: 'Got it',
      see_all: 'See all updates',
      dismiss: 'Dismiss',
      back_to_help: 'Back to Help',
      empty: 'No release notes have been published yet.',
    },
    help: {
      menu_title: 'Help & Support',
      page_title: 'VetPo Help Center',
      title: 'Help & Support',
      welcome_message:
        'Welcome to the Adapet Help Center. Find guides, tutorials, and support resources to help you use your glucose monitoring system effectively.',
      current_language: 'Current language',
      user_guides: 'User Guides',
      user_guides_desc:
        'Comprehensive guides to help you navigate and use Adapet Vet Portal effectively.',
      quick_start: 'Quick Start Guide',
      quick_start_desc: 'Get started with VetPo system basics and navigation.',
      features_guide: 'Features Guide',
      features_guide_desc: 'Complete overview of all VetPo features and capabilities.',
      reading_tables: 'Reading Tables',
      reading_tables_desc: 'Learn how to interpret data tables and quality indicators.',
      understanding_charts: 'Understanding Charts',
      understanding_charts_desc: 'Master glucose trend charts and analytics visualizations.',
      faq: 'Frequently Asked Questions',
      faq_desc: 'Common questions and troubleshooting solutions.',
      open_guide: 'Open Guide',
      quick_reference: 'Quick Reference',
      quick_ref: {
        navigation: 'Basic Navigation',
        navigation_desc: 'Use sidebar menu to access different sections',
        pet_selection: 'Pet Selection',
        pet_selection_desc:
          'Select View on a patient in the dashboard to open their glucose detail',
        glucose_monitoring: 'Glucose Monitoring',
        glucose_monitoring_desc: 'View real-time data and trends in charts',
      },
      support_contact: 'Support & Contact',
      support_desc: 'Get product and technical support for Adapet Vet Portal.',
      support: {
        email: 'Email Support',
        email_desc: 'support@adapetmedical.com - Response within 24 hours',
        chat: 'Live Chat',
        chat_desc: 'Available during business hours',
        phone: 'Phone Support',
        phone_desc: '1-888-444-2618 - Phone support for urgent issues',
        chat_available:
          'Live chat is available! Look for the chat icon in the bottom-right corner of your screen.',
      },
      contact: 'Contact',
      emergency_notice_title: 'Emergency Notice',
      emergency_notice_desc:
        'For immediate veterinary emergencies, always prioritize direct clinical assessment over system data. VetPo provides monitoring tools but does not replace professional veterinary judgment.',
    },
    users: {
      access_denied: 'Access denied. Site administrators only.',
      col_role: 'Role',
      col_clinic: 'Clinic',
      col_actions: 'Actions',
      promote_success: '%{email} promoted to Group Administrator',
      promote_confirm: 'Promote %{email} to Group Administrator (vetadmin)?',
      promote_failed: 'Failed to promote user',
      manage_users: 'Manage Users',
      promote_button: 'Promote to Group Administrator',
      role_vet: 'Veterinarian',
      role_vetadmin: 'Group Administrator',
      role_admin: 'System Administrator',
      role_siteadmin: 'Site Administrator',
      role_cms: 'Content Manager',
      role_user: 'Client',
      current_language: 'Current language',
      user_guides: 'User Guides',
      user_guides_desc: 'Comprehensive guides to help you navigate and use VetPo effectively.',
      quick_start: 'Quick Start Guide',
      quick_start_desc: 'Get started with VetPo system basics and navigation.',
      features_guide: 'Features Guide',
      features_guide_desc: 'Complete overview of all VetPo features and capabilities.',
      reading_tables: 'Reading Tables',
      reading_tables_desc: 'Learn how to interpret data tables and quality indicators.',
      understanding_charts: 'Understanding Charts',
      understanding_charts_desc: 'Master glucose trend charts and analytics visualizations.',
      faq: 'Frequently Asked Questions',
      faq_desc: 'Common questions and troubleshooting solutions.',
      open_guide: 'Open Guide',
      quick_reference: 'Quick Reference',
      quick_ref: {
        navigation: 'Basic Navigation',
        navigation_desc: 'Use sidebar menu to access different sections',
        pet_selection: 'Pet Selection',
        pet_selection_desc:
          'Select View on a patient in the dashboard to open their glucose detail',
        glucose_monitoring: 'Glucose Monitoring',
        glucose_monitoring_desc: 'View real-time data and trends in charts',
      },
      support_contact: 'Support & Contact',
      support_desc: 'Get help when you need it most.',
      support: {
        email: 'Email Support',
        email_desc: 'support@adapetmedical.com - Response within 24 hours',
        chat: 'Live Chat',
        chat_desc: 'Available during business hours',
        phone: 'Phone Support',
        phone_desc: '1-888-444-2618 - Emergency support for critical issues',
        chat_available:
          'Live chat is available! Look for the chat icon in the bottom-right corner of your screen.',
      },
      contact: 'Contact',
      emergency_notice_title: 'Emergency Notice',
      emergency_notice_desc:
        'For immediate veterinary emergencies, always prioritize direct clinical assessment over system data. VetPo provides monitoring tools but does not replace professional veterinary judgment.',
    },
    chat: {
      title: 'Live Support',
      welcome_message:
        'Hello! How can I help you today? I can assist with questions about Adapet Vet Portal features, glucose monitoring, or technical issues.',
      input_placeholder: 'Type your message...',
      send: 'Send',
      typing: 'Support is typing',
      status_online: 'Online',
      status_offline: 'Offline',
      powered_by: 'Powered by Adapet Support',
      error_general: 'Sorry, I encountered an error. Please try again.',
      error_network: 'Network error. Please check your connection and try again.',
      minimize: 'Minimize',
      close: 'Close chat',
      unread_indicator: 'New message',
    },
    client_profile: {
      edit_client: 'Edit Client',
      dialog_title: 'Edit Client Details',
      save: 'Save',
      saved: 'Client details updated.',
      save_error: 'Could not update the client. Please try again.',
      not_allowed: 'You do not have permission to edit this client.',
      name_too_short: 'Client name must be at least 2 characters.',
      read_only_hint: 'Only the clinic linked to this client can edit their details.',
    },
    pet_edit: {
      some_fields_read_only:
        'Some fields are read-only for your role. Changes to them are not saved.',
      all_fields_read_only: 'This pet is read-only for your role. Changes are not saved.',
      pet_information: 'Pet information',
      basic_details_readonly: 'Basic Pet Information (Read-only)',
      basic_details_editable: 'Basic details about the patient and their client.',
      owner_name: 'Client Name',
      editable_fields: 'Measurements',
      vet_modifiable_fields: 'Height and weight as recorded at the clinic.',
      chronic_care: 'Chronic-care profile',
      chronic_care_hint:
        'Vet-managed clinical fields. These feed the diabetes glucose-target band and the AdapetApp calorie-balance display.',
      weight_kg_hint:
        'Numeric weight in kilograms. Auto-filled from the text weight field if empty.',
      birth_date_hint: 'Calendar date. Falls back to date of birth if empty.',
      kcal_override_hint:
        'When set, replaces the RER × activity-factor estimate as the daily energy target.',
      auto_save: {
        saving: 'Saving...',
        saved: 'Pet information saved',
        error: 'Failed to save pet information',
        unsaved_changes: 'Unsaved changes',
        last_saved: 'Last saved at %{time}',
      },
    },
    alert_rules: {
      // Toasts from the rules editor (messageArgs: rule = translated rule name).
      toast: {
        already_exists: '%{rule} already exists',
        update_not_found: 'Could not find existing rule %{rule} to update',
        update_failed: 'Failed to update existing rule %{rule}',
        permission_denied:
          'Permission denied: Cannot save alert rules. Please check your access rights.',
        save_rule_failed: 'Failed to save %{rule}: %{error}',
        saved_partial: 'Saved %{saved} of %{total} rules. Some rules failed to save.',
        save_failed_details:
          'Failed to save alert rules. Please check browser console for details.',
        save_failed: 'Failed to save alert rules',
      },
      per_15min: '%{unit} per 15 min',
      delete_failed: 'Could not delete the rule — it is still active. Please try again.',
      title: 'Glucose Alert Rules',
      glucose_range: 'Glucose Range',
      copy: {
        prompt:
          'This looks like a new sensor profile for "%{name}", which already has %{count} alert rule(s). Copy its thresholds?',
        review_hint: 'Review and adjust the copied thresholds below — changes save automatically.',
        action: 'Review & copy',
        copied: 'Thresholds copied — review the values below.',
        none_found: 'No alert thresholds found on the previous profile.',
        failed: 'Could not copy thresholds from the previous profile.',
      },
      unsaved_changes: 'Unsaved Changes',
      configuration_desc:
        'Configure glucose monitoring thresholds and alert conditions for this patient',
      configuration_info:
        'Set custom glucose thresholds for this patient. The glucose range will be calculated based on the configured thresholds. Rules will trigger alerts when readings fall below or rise above these thresholds.',
      add_rule_tooltip: 'Add new alert rule',
      save_rules: 'Save Rules',
      saving: 'Saving...',
      loading: 'Loading alert rules...',
      no_rules_configured:
        'No alert rules configured. Click "Add Rule" to create glucose monitoring rules for this patient.',
      rule_types: {
        critical_hypoglycemia: 'Critical Hypoglycemia',
        warning_hypoglycemia: 'Warning Hypoglycemia',
        critical_hyperglycemia: 'Critical Hyperglycemia',
        warning_hyperglycemia: 'Warning Hyperglycemia',
        rapid_drop: 'Rapid Drop',
        dawn_pattern: 'Morning Glucose Pattern',
        somogyi_pattern: 'Possible Rebound Pattern',
        postprandial_spikes: 'Post-meal Glucose Spikes',
      },
      thresholds: {
        critical_threshold: 'Critical Threshold',
        warning_threshold: 'Warning Threshold',
        hyperglycemia_threshold: 'Hyperglycemia Threshold',
        severe_hyperglycemia_threshold: 'Severe Hyperglycemia Threshold',
        somogyi_rebound_threshold: 'Somogyi Rebound Threshold',
        dawn_elevation_threshold: 'Dawn Elevation Threshold',
        drop_threshold: 'Drop Threshold',
        analysis_window: 'Analysis Window (hours)',
        postprandial_spike_threshold: 'Postprandial Spike Threshold',
        severe_spike_threshold: 'Severe Spike Threshold',
        postprandial_window_hours: 'Post-Meal Window (hours)',
        pre_meal_window_hours: 'Pre-Meal Window (hours)',
      },
      fields: {
        rule_type: 'Rule Type',
        unit: 'Unit',
        trigger_count: 'Trigger Count',
        trigger_count_helper: 'Read-only usage count',
        notes: 'Notes',
        notes_placeholder: 'Brief description or notes about this rule',
        active: 'Active',
        active_status: 'Active',
        inactive_status: 'Inactive',
        email_notifications: 'Email Notifications',
        sms_notifications: 'SMS Notifications',
      },
      notification_settings: 'Notification Settings',
      delete_rule_tooltip: 'Delete this rule',
      add_rule: 'Add Rule',
      load_failed:
        "Could not load this patient's alert rules. Nothing is shown or saved until they load.",
      retry: 'Retry',
      saving_previous:
        "Saving this patient's previous changes… You can leave this page; the save continues.",
      unsaved_invalid: 'Some alert thresholds for %{name} were invalid and were not saved.',
      unsaved_failed: 'Some alert thresholds for %{name} could not be saved.',
      save: 'Save',
      auto_saving: 'Auto-saving...',
      all_rule_types_added: 'All rule types added',
      help_text: {
        critical_hypoglycemia:
          'Triggers critical alerts when glucose falls below this threshold. Requires prompt veterinary review.',
        warning_hypoglycemia:
          'Triggers warning alerts when glucose falls below this threshold. Requires monitoring.',
        critical_hyperglycemia:
          'Triggers critical alerts when glucose rises above this threshold. Very high readings may require veterinary review.',
        warning_hyperglycemia:
          'Triggers warning alerts when glucose rises above this threshold. Requires monitoring.',
        rapid_drop:
          'Triggers alerts when glucose drops by the specified rate over time. Uses rapid drop threshold for detection and warning threshold for hypoglycemia monitoring.',
        dawn_pattern:
          'Flags morning glucose elevation patterns based on the specified time window.',
        somogyi_pattern:
          'Flags possible rebound patterns after low-glucose episodes. Requires an analysis window for pattern review.',
        postprandial_spikes:
          'Flags glucose spikes after meals by comparing post-meal glucose to pre-meal baseline.',
      },
      somogyi_note:
        'Note: Nighttime hypoglycemia threshold is automatically determined from your existing Critical or Warning Hypoglycemia rules. Configure those rules separately to set the nighttime low threshold (10 PM - 6 AM).',
      help_ranges: {
        critical_threshold:
          'Range: 1.0-4.0 mmol/L. Very low readings require prompt veterinary review.',
        warning_threshold: 'Range: 3.0-5.5 mmol/L. Must be above critical threshold.',
        hyperglycemia_threshold:
          'Range: 8.0-25.0 mmol/L. Should be lower than the severe hyperglycemia threshold.',
        severe_hyperglycemia_threshold:
          'Range: 12.0-30.0 mmol/L. Very high readings may require prompt veterinary review.',
        somogyi_rebound_threshold: 'Range: 6.0-20.0 mmol/L. Morning rebound glucose level.',
        dawn_elevation_threshold: 'Range: 5.0-15.0 mmol/L. Morning glucose elevation threshold.',
        rapid_drop_threshold:
          'Range: 1.0-5.0 mmol/L per 15 minutes. Rate of glucose decline that triggers rapid drop alerts. Algorithm analyzes last 30 minutes of data.',
        analysis_window: 'Range: 12-72 hours. Time period for pattern analysis.',
        postprandial_spike_threshold:
          'Range: 3.0-10.0 mmol/L. Custom spike threshold above baseline.',
        severe_spike_threshold: 'Range: 5.0-15.0 mmol/L. Higher threshold for severe spikes.',
        postprandial_window_hours:
          'Range: 2.0-6.0 hours. Time window after meals to monitor spikes.',
        pre_meal_window_hours:
          'Range: 0.5-3.0 hours. Time window before meals for baseline calculation.',
      },
      metadata: {
        last_triggered: 'Last triggered',
        total_triggers: 'Total triggers',
      },
      notifications: {
        saved_successfully: 'Alert rules saved successfully',
        saved_locally: 'Alert rules saved locally (server unavailable)',
        could_not_load: 'Could not load alert rules. Using defaults.',
      },
      validation: {
        required: 'This field is required',
        out_of_range: 'Value must be between {min} and {max} {unit}.',
        critical_threshold: 'Critical threshold is outside the allowed range.',
        warning_threshold: 'Warning threshold is outside the allowed range.',
        hyperglycemia_threshold: 'Hyperglycemia threshold is outside the allowed range.',
        severe_hyperglycemia_threshold:
          'Severe hyperglycemia threshold is outside the allowed range.',
        somogyi_rebound_threshold: 'Possible rebound threshold is outside the allowed range.',
        dawn_elevation_threshold:
          'Dawn elevation threshold must be between 5.0 and 15.0 mmol/L (90-270 mg/dL)',
        rapid_drop_threshold: 'Rapid drop threshold is outside the allowed range.',
        postprandial_spike_threshold:
          'Postprandial spike threshold must be between 3.0 and 10.0 mmol/L (54-180 mg/dL)',
        severe_spike_threshold: 'Severe spike threshold is outside the allowed range.',
        postprandial_window_hours: 'Post-meal window must be between 2.0 and 6.0 hours',
        pre_meal_window_hours: 'Pre-meal window must be between 0.5 and 3.0 hours',
        analysis_window: 'Analysis window must be between 12 and 72 hours',
        cannot_save_with_errors: 'Cannot save: Please fix validation errors before saving',
      },
    },
    alerts: {
      // Fallbacks for an alert that arrived without a title / message, and the toasts
      // shown when the vet jumps from an alert to the chart.
      fallback_title: 'Alert',
      fallback_message: 'No details available',
      navigating_chart: 'Navigating to glucose chart at %{time}%{glucose}',
      navigating_patterns: 'Navigating to glucose patterns around %{date}',
      navigating_overview: 'Navigating to pet overview for alert: %{title}',
      not_available_for_role:
        "Alerts are not available for your account type. Ask a vet account to review this patient's alerts.",
      // Shown when the permission CHECK itself failed — never conflate with the
      // line above, which is a statement about the account (eng-brain P32-3).
      access_unknown:
        'Could not check alerts right now. This is a connection problem, not a permission change.',
      access_retry: 'Try again',
      fetch_error_auth: 'Alert feed paused — please refresh to sign in again.',
      fetch_error_unavailable: 'Alert feed unavailable — showing the last known state.',
      title: 'Alerts',
      total: 'total',
      no_alerts: 'No alerts match the current filters',
      alert_context: 'Alert Context',
      recommendations: 'Review Notes',
      details: 'Details',
      acknowledge: 'Acknowledge',
      acknowledged: 'Acknowledged',
      active: 'Active',
      resolved: 'Resolved',
      dismissed: 'Dismissed',
      unacknowledged_count: '%{count} unacknowledged',
      refresh_tooltip: 'Refresh alerts',
      monitoring_issue: 'Alert Monitoring Issue',
      monitoring_issue_retry: 'Alerts may not be up to date. Refresh to try again.',
      no_recent_alerts: 'No recent alerts',
      checking_interval: 'Checking for alerts every %{minutes} minutes',
      acknowledged_at: 'Acknowledged: %{time}',
      acknowledge_success: 'Alert acknowledged successfully',
      acknowledge_failed: 'Failed to acknowledge alert',
      acknowledge_tooltip: 'Acknowledge alert',
      mark_resolved: 'Mark as Resolved',
      resolve_hint: 'Reviewed and handled? Add an optional note, then resolve.',
      resolve_notes_placeholder:
        'Resolution note (optional) — e.g. adjusted insulin, no action needed…',
      resolved_at: 'Resolved: %{time}',
      resolution_note: 'Note: %{note}',
      show_resolved: 'Show resolved alerts',
      hide_resolved: 'Hide resolved alerts',
      resolved_count: '%{count} resolved',
      all_resolved: 'All alerts resolved',
      show_details: 'Show details',
      pet_alerts: 'Patient %{petId} alerts',
      all_pets: 'All patients',
      showing_count: 'Showing %{shown} of %{total} alerts',
      critical_require_attention: '%{count} critical alert(s) require prompt veterinary review',
      critical_alerts_count: '%{count} critical alert(s)',
      active_alerts_count: '%{count} Active Alerts',
      navigate_cannot: 'Unable to open this alert because the patient ID is missing.',
      filter: {
        severity: 'Severity',
        type: 'Type',
        status: 'Status',
        all: 'All',
        hypoglycemia: 'Hypoglycemia',
        hyperglycemia: 'Hyperglycemia',
        somogyi: 'Somogyi',
        trend: 'Trend',
      },
      type: {
        hypoglycemia: 'Low Glucose',
        critical_hypoglycemia: 'Critical Low',
        hyperglycemia: 'High Glucose',
        rapid_drop: 'Rapid Drop',
        pattern_detected: 'Pattern',
        somogyi: 'Possible Rebound Pattern',
        sensor_failure: 'Sensor Issue',
        trend: 'Trend Analysis',
        trend_analysis: 'Trend Analysis',
        system: 'System Alert',
      },
      severity: {
        critical: 'Critical',
        high: 'High',
        medium: 'Medium',
        low: 'Low',
      },
      messages: {
        critical_attention: 'Critical alert(s) require prompt veterinary review',
        hypoglycemia_detected: 'Low glucose readings recorded below the selected target range',
        hyperglycemia_detected: 'High glucose readings recorded above the target range',
        somogyi_detected: 'Possible rebound pattern flagged for veterinary review',
        trend_analysis_available: 'New glucose trend analysis available',
      },
      configuration: {
        title: 'Alert Configuration',
        description: 'Configure alert thresholds and trend detection settings',
        hypoglycemia_section: 'Hypoglycemia Detection',
        hyperglycemia_section: 'Hyperglycemia Detection',
        somogyi_section: 'Somogyi Phenomenon Detection',
        trend_analysis_section: 'Trend Analysis',
        custom_rules_section: 'Custom Alert Rules',
        save_config: 'Save Configuration',
        reset_config: 'Reset to Defaults',
        apply_preset: 'Apply Preset',
        presets: {
          conservative: 'Conservative (High Sensitivity)',
          standard: 'Standard (Balanced)',
          aggressive: 'Aggressive (Low Sensitivity)',
        },
      },
      thresholds: {
        critical_threshold: 'Critical Threshold',
        high_threshold: 'High Priority Threshold',
        medium_threshold: 'Medium Priority Threshold',
        confidence_threshold: 'Minimum Confidence',
        rebound_magnitude: 'Minimum Rebound Magnitude',
      },
      notifications: {
        email_sent: 'Email notification sent',
        push_sent: 'Push notification sent',
        dashboard_updated: 'Dashboard notification created',
        vet_warning_sent: 'Veterinary alert notification sent',
        daily_report_sent: 'Daily report sent',
      },
      reports: {
        daily_report: 'Daily Monitoring Report',
        summary_title: 'Alert Summary',
        glucose_summary: 'Glucose Summary',
        patterns_detected: 'Patterns Detected',
        ai_recommendations: 'System-generated insights',
        report_period: 'Report Period',
        total_readings: 'Total Readings',
        time_in_range: 'Time in Range',
        episodes_count: 'Episodes Count',
        generate_report: 'Generate Report',
        download_report: 'Download Report',
        email_report: 'Email Report',
      },
    },
    menu: {
      section_patients: 'Clients',
      section_sharing: 'Collaboration',
      section_admin: 'Administration',
      clinic_teams: 'Clinic Team',
      clinic_team: 'Clinic Team',
      care_teams: 'Care Teams',
      all_teams_readonly: 'All Teams (Read-Only)',
      manage_users: 'Manage Users',
      my_account: 'My Account',
      register_owner: 'Add New Client',
      owners_hint: 'Clients registered at your clinic, and the pets belonging to each of them.',
      register_owner_hint:
        'Create an account for a client during their clinic visit — they receive an email to set a password and activate it.',
      notes_hint: 'EMRs you have written for your patients',
      pet_shares_hint:
        'Share specific pets (or all your pets) with another veterinarian, and see pets other vets have shared with you.',
      clinic_team_hint:
        'Manage your clinic’s veterinarians: create sub-accounts and assign patients so alerts reach the responsible vet.',
      care_teams_hint:
        'Clinics don’t need a Care Team. Manage your clinic’s vets in Clinic Team, and share patients with a colleague in Pet Shares.',
      sales: 'Sales',
      catalog: 'Catalog',
      customers: 'Customers',
    },
    events: {
      review: {
        title: 'Added note for "%{product}"',
      },
      order: {
        title: 'Ordered 1 poster |||| Ordered %{smart_count} posters',
      },
    },
    export: {
      button: 'Export',
      pdf: 'Export as PDF',
      image: 'Export as Image',
    },
    glucose: {
      no_devices_found: 'No glucose monitoring devices found for this pet.',
      trend_over_time: 'Glucose Trend Over Time',
      suspected_detachment: 'Suspected sensor detachment — data hidden for safety review',
      statistics_range: 'Glucose Statistics & Range Analysis',
      time_in_range_analysis: 'Time in Range Analysis',
      no_data_available: 'No data available',
      event_band: 'Activity Events Timeline',
      view_day: 'Day',
      view_week: 'Week',
      view_month: 'Month',
      reset_view: 'Reset view',
      reset_group: 'Reset group',
      reset_selection: 'Reset selection',
      select_date: 'Select Date',
      start_date: 'Start Date',
      end_date: 'End Date',
      date_range: 'Date Range',
      single_date: 'Single Date',
      filter_date_range: 'Filter Date Range',
      available_range: 'Available range',
      configure_target_range: 'Configure Target Range',
      target_range_save_failed:
        'Saving the target range failed — the previous range is still shown.',
      show_activity_markers: 'Show Activity Markers',
      hide_activity_markers: 'Hide Activity Markers',
      target_range_settings: 'Target Range Settings',
      target_low: 'Target Low',
      target_high: 'Target High',
      current_unit: 'Current unit',
      out_of_range: 'Out of range',
      // Chart tooltip: the plotted point is a trailing moving average, so it can
      // differ from the underlying reading during a fast rise/fall.
      tooltip_avg: 'avg',
      tooltip_reading: 'reading',
      target_range_preview: 'Preview',
      species_fallback_notice:
        'No reference range is defined for %{species}. The values shown are dog defaults — set a range for this patient if they do not apply.',
      loading_stats: 'Loading stats...',
      error_loading_stats: 'Error loading stats:',
      glucose_statistics: 'Glucose Statistics',
      image_export_requires: 'Image export is currently unavailable. Please try again later.',
      days: 'Days',
      active_data_days: 'Active Data Days',
      time_sensor_active: 'Time Sensor Active:',
      healthy_glucose_range: 'Selected Target Range:',
      below_range: 'Below Range',
      above_range: 'Above Range',
      average_glucose: 'Average Glucose',
      glucose_variability: 'Glucose Variability (CV)',
      target_cv_message:
        'Lower glucose variability may support better glycemic management. Interpret with clinical context.',
      snapshot: 'Snapshot',
      libre_view: 'CGM Data View',
      average_glucose_caps: 'AVERAGE GLUCOSE',
      percent_above_target: '% above target',
      percent_in_target: '% in target',
      percent_below_target: '% below target',
      low_glucose_events: 'Low Glucose Events',
      average_duration: 'Average duration:',
      carbs: 'Food',
      carbohydrate_intake: 'MEAL / FOOD INTAKE',
      insulin: 'INSULIN',
      rapid_acting_insulin: '💉 RAPID-ACTING INSULIN',
      long_acting_insulin: 'LONG-ACTING INSULIN',
      total_daily_insulin: '📊 TOTAL DAILY INSULIN',
      comments: 'Comments',
      min: 'Min',
      no_significant_issues: 'No significant issues detected in this period.',
      loading_chart: 'Loading chart...',
      error_loading_chart: 'Error loading chart',
      time_in_range: 'Time in Range',
      tir_distribution: 'Time in Range Distribution',
      very_high: 'Very High',
      high: 'High',
      target: 'Target',
      low: 'Low',
      very_low: 'Very Low',
      unit: 'mmol/L',
      hour_abbr: 'h',
      minute_abbr: 'min',
      gram_abbr: 'g',
      unit_abbr: 'u',
      summary_report: 'Summary Report',
      report_period: 'Report Period',
      report_generated: 'Report Generated',
      sensor_coverage: 'Sensor Coverage',
      standard_deviation: 'Standard Deviation (SD)',
      effective_days: 'Effective Days',
      data_from_continuous_monitoring: 'Data from 3-minute interval continuous monitoring',
      range_distribution: 'TIR (Time in Range)',
      ideal_targets: 'Reference Targets',
      target_range_goal: 'Time in target range ≥70%',
      low_glucose_goal: 'Low glucose exposure should be reviewed by the attending veterinarian.',
      variability_goal: 'Coefficient of variation <36%',
      zoom_view: 'Zoom View',
      zoom_chart: 'Zoom Chart',
      close_zoom: 'Close Zoom',
      detailed_view: 'Detailed View',
      summary_metrics: 'Summary Metrics',
      show_events: 'Show Events',
      hide_events: 'Hide Events',
      previous_day: 'Previous Day',
      next_day: 'Next Day',
      duration_in_range: 'Duration in Range',
      zoom_tooltip: 'Click to zoom in on this day',
      before_device_start: 'Before device activation',
      // Dashboard Part 2 - TIR Summary
      tir_statistics: 'TIR Statistics',
      target_range: 'Target Range',
      time_below_range: 'Time Below Range (TBR)',
      time_above_range: 'Time Above Range (TAR)',
      data_coverage: 'Data Coverage',
      readings: 'readings',
      unit_mmol: 'mmol/L',
      time: 'Time',
      glucose: 'Glucose',
      // Dashboard Part 7 - Low Glucose Events
      events: 'events',
      showing_events_below: 'Showing events below %{threshold} %{unit}',
      // One episode = consecutive readings below threshold (not one per reading)
      episode_duration: '%{minutes} min below threshold',
      episode_readings: '%{count} readings below threshold',
      no_low_events: 'No low glucose events detected',
      no_low_events_description: 'No readings below %{threshold} %{unit} in this period',
      // Loading/error states
      loading_snapshot: 'Loading snapshot...',
      error_loading_snapshot: 'Error loading snapshot',
      loading_range_bar: 'Loading range bar...',
      error_loading_range_bar: 'Error loading range bar',
      loading_daily_tir: 'Loading daily TIR chart...',
      error_loading_daily_tir: 'Error loading daily TIR chart',
      error_loading_trend: 'Error loading chart',
      // Chart labels
      glucose_range_distribution: 'Glucose Range Distribution',
      time_format_note: 'Time format: HH:MM (based on 3-minute reading intervals)',
      time_in_range_percent: 'Time in Range (%)',
      glucose_overline: 'Glucose',
      target_range_label: 'Target Range',
      no_data_text: 'No data',
      showing_devices: 'Showing data from %{count} devices',
      estimated: '(Estimated)',
      y_position_estimated: '(Y position estimated)',
      view_all: 'All',
      // Auto-generated comments
      auto_comment_missing_insulin: '%{days} days in this period have no recorded insulin events.',
      auto_comment_no_carbs: 'No meal records were available for this period.',
      auto_comment_high_low_events:
        'High number of low glucose readings (%{count}) recorded. Review insulin timing, meal records, clinical signs, and confirmatory blood glucose testing.',
      // SummaryReportSection metric card labels
      avg_glucose_short: 'Avg Glucose',
      cv_short: 'CV',
      std_dev_short: 'Std Dev',
      coverage_suffix: 'coverage',
      // GlucoseLineChart
      error_loading_chart_detail: 'Error loading chart: %{error}',
      // Non-blocking indicator: the activities (insulin/food/exercise marker)
      // fetch failed while the glucose curve itself loaded fine.
      activity_markers_load_error: 'Activity markers could not be loaded',
      // Structured meal/insulin overlay markers (vic/vetpo#15)
      meal_status_normal: 'Ate Normally',
      meal_status_less: 'Ate Less Than Usual',
      meal_status_none: 'Did Not Eat',
      insulin_dose_skipped: 'Not given',
      insulin_dose_late_suffix: '(late)',
      insulin_units_abbr: 'units',
      insulin_exception_triggered: 'Alternative instruction triggered',
    },
    // Dashboard Part 3 - AGP
    agp: {
      time_of_day: 'Time of Day',
      title: 'Ambulatory Glucose Profile',
      percentile_bands: 'Percentile Bands',
      median: 'Median (50th)',
      percentile_5_95: '5th–95th percentile',
      percentile_25_75: '25th–75th percentile',
      hover_time: 'Time',
      hover_median: 'Median',
    },
    // Dashboard Part 3 - Vet Internal Notes
    notes: {
      vet_notes: 'Vet Internal Notes',
      hospital_only_subtitle: 'Visible only to your hospital team',
      add_note: 'Add Note',
      save_note: 'Save Notes',
      enter_note: 'Enter your clinical note...',
      no_notes: 'No notes yet',
      add_first_note: 'Add the first note for this pet',
      total_notes: '%{count} notes',
      show_more: 'Show more',
      show_less: 'Show less',
      select_pet_first: 'Select a pet to view notes',
      created_successfully: 'Note created successfully',
      error_creating: 'Error creating note',
      include_in_report: 'Include in PDF reports',
      include_in_report_help: 'Uncheck for internal notes only',
      internal_note: 'Internal',
    },
    // Dashboard Part 5 - Treatment Plan & Home Instructions (vic/vetpo#14)
    treatmentPlan: {
      title: 'Treatment Plan & Home Instructions',
      select_pet_first: 'Select a pet to view the treatment plan',
      error_loading: 'Error loading treatment plan',
      no_plan_yet: 'No plan yet',
      create_plan: 'Create plan',
      edit: 'Edit',
      cancel: 'Cancel',
      save_and_send: 'Save & Send to Owner App',
      saved_successfully: 'Treatment plan saved and sent to the owner app',
      error_saving: 'Error saving treatment plan',
      insulin_plan_section: 'Insulin Plan',
      insulin_product_label: 'Insulin product',
      insulin_product_placeholder: 'Select insulin product',
      insulin_dose_label: 'Dose (units)',
      syringe_matched: '✓ %{syringe} automatically matched',
      meal_plan_section: 'Meal Plan',
      add_time: 'Add time',
      remove_time: 'Remove time',
      exceptions_section: "If pet doesn't eat normally → Set instructions",
      eating_less_label: 'Eating less than usual',
      eating_less_placeholder: 'Instructions for the owner...',
      not_eating_label: 'Did not eat',
      not_eating_placeholder: 'Instructions for the owner...',
      meal_reminders_label: 'Meal reminders',
      home_instructions_section: 'Home Instructions',
      home_instructions_placeholder: 'Optional notes for the owner app...',
      summary_insulin: 'Insulin: %{dose} units, %{product}',
      summary_insulin_no_dose: 'Insulin: %{product}',
      summary_no_insulin: 'No insulin plan set',
      summary_meal_times: 'Meal times: %{times}',
      summary_no_meal_times: 'No meal times set',
      summary_reminders_on: 'Meal reminders: On',
      summary_reminders_off: 'Meal reminders: Off',
      summary_home_instructions: 'Home instructions set',
      last_updated: 'Last updated %{date}',
    },
    // Dashboard Part 6 - Activities
    activities: {
      no_activities: 'No activities recorded',
    },
    export_selection: {
      by_device: 'By sensor',
      by_device_hint: 'Tick one or more sensors. The report covers exactly their wear period.',
      custom_range: 'Custom date range',
      loading_devices: 'Loading sensors…',
      devices_error: 'Could not load the sensor list. Use a custom date range instead.',
      no_devices: 'No sensor readings found for this patient.',
      no_readings: 'No readings',
      short_wear: '<3 days',
      short_wear_hint: 'This sensor sent 3 days of data or less.',
      days_worn: '%{smart_count} day |||| %{smart_count} days',
      select_one: 'Select at least one sensor.',
      report_window: 'Report window',
      clamped_hint: "Limited to this patient's data (%{start} – %{end}).",
      csv_dialog_title: 'Export CSV',
    },
    pdf: {
      generate_report: 'Generate Report',
      preparing: 'Preparing report...',
      capturing: 'Preparing charts...',
      generating: 'Preparing report...',
      complete: 'Report ready',
      status_description: {
        preparing: 'Preparing report data',
        capturing: 'Preparing chart visuals',
        generating: 'Creating report document',
      },
      // Part 8: Date range picker translations
      select_date_range: 'Select Report Date Range',
      quick_presets: 'Quick presets',
      last_7_days: 'Last 7 days',
      last_14_days: 'Last 14 days',
      last_30_days: 'Last 30 days',
      last_90_days: 'Last 90 days',
      report_period: 'Report period',
      days: 'days',
      pet_aggregated_notice: 'Report will include data from all devices associated with this pet.',
      no_data_warning: 'No glucose data available for the selected date range.',
      actual_data_range: 'Data available',
      use_actual_range: 'Use data range',
      checking_data: 'Checking available data…',
      report_load_error:
        'Could not load the readings or notes for this range — the report is unavailable. Reload the page or try again.',
      empty_confirm_title: 'No data in selected range',
      empty_confirm_message:
        'The selected date range has no glucose readings. The report may not include glucose charts or metrics.',
      empty_confirm_no_data:
        'This patient does not have glucose readings yet. A report cannot include glucose metrics until data are available.',
      generate_anyway: 'Continue without glucose data',
    },
    // Veterinary CGM Report translations (6-page format)
    vet_report: {
      title: 'Adapet CGM Veterinary Report',
      report_overview: 'Report Overview',
      glucose_control_summary: 'Glucose Control Summary',
      key_findings: 'Key findings',
      tir_statistics: 'TIR statistics',
      time_in_ranges: 'Time in ranges',
      target_range: 'Target Range',
      time_in_range_tir: 'Time in Range (TIR)',
      time_below_range_tbr: 'Time Below Range (TBR)',
      time_above_range_tar: 'Time Above Range (TAR)',
      average_glucose: 'Average Glucose',
      data_coverage: 'Data Coverage',
      range: 'Range',
      percent: '%',
      time: 'Time',
      // Page 2: AGP
      agp: 'AGP',
      ambulatory_glucose_profile: 'Ambulatory Glucose Profile (AGP)',
      pattern_summary: 'Pattern summary',
      time_block: 'Time block',
      median: 'Median',
      iqr: 'IQR (25-75)',
      comment: 'Comment',
      // Page 3: Glucose Trend
      glucose_trend: 'Glucose Trend',
      glucose_trend_window: 'Glucose trend (report window)',
      target_range_band_note: 'Chart range is based on the selected glucose display settings.',
      notable_segments: 'Notable segments & annotations',
      date_time: 'Date/Time',
      type: 'Type',
      value: 'Value',
      notes_column: 'Notes',
      no_notable_segments: 'No notable segments detected in this period.',
      // Page 4: Daily Overview
      daily_overview: 'Daily Overview',
      daily_time_in_ranges: 'Daily time in ranges',
      daily_metrics: 'Daily metrics',
      date: 'Date',
      avg: 'Avg',
      min_max: 'Min-Max',
      tir: 'TIR',
      tar: 'TAR',
      tbr: 'TBR',
      readings: 'Readings',
      activities_column: 'Activities',
      // Page 5: Daily Trends
      daily_trends: 'Daily Trends',
      no_daily_data: 'No daily data available for the selected period.',
      no_activities_recorded: 'No activities recorded',
      // Page 6: Events & Notes
      events_and_notes: 'Events & Notes',
      low_glucose_events: 'Low glucose events (below threshold)',
      events_disclaimer:
        'Events are sensor readings flagged below the configured threshold. Interpret with clinical correlation.',
      glucose_mmol: 'Glucose',
      severity: 'Severity',
      no_low_events: 'No low glucose events detected during this period.',
      veterinary_assessment: 'Veterinary Review Notes',
      clinician: 'Clinician',
      // Footer
      footer_disclaimer:
        'Generated for veterinary review. Interpret in clinical context; verify with confirmatory testing when needed.',
      page_of: 'Page %{page} of %{total}',
    },
    // New-version prompts (banner + forced-reload dialog) and the section error fallback.
    app_update: {
      dialog_title: 'VetPo needs to update',
      dialog_body:
        'This tab is running an outdated version of VetPo and must reload to keep working correctly. Please finish or copy any unsaved note now.',
      reloading_in: 'Reloading automatically in %{seconds}s…',
      reload_now: 'Reload now',
      banner_message: 'A new version of VetPo is available%{versions}. Refresh to update.',
      refresh: 'Refresh',
    },
    error_boundary: {
      unable_to_load: 'Unable to load %{name}',
      content: 'content',
      render_error: 'An error occurred while rendering this section.',
      try_again: 'Try Again',
      names: {
        treatment_plan: 'Treatment Plan',
        glucose_trend: 'Glucose Trend Chart',
        daily_tir: 'Daily TIR Chart',
        agp: 'AGP Chart',
        daily_trends: 'Daily Trends',
        low_events: 'Low Glucose Events',
      },
    },
    // Group membership list (a site-admin resource).
    group_members: {
      col_consent: 'Consent',
      status: {
        active: 'Active',
        invited: 'Invited',
        declined: 'Declined',
        pending_consent: 'Pending consent',
      },
      consent: { granted: 'Granted', pending: 'Pending', denied: 'Denied' },
    },
    // Signed-out pages that render BEFORE <Admin> (App.tsx wraps them in I18nContextProvider).
    sso: {
      expired_title: 'Sign-in link expired',
      expired_body:
        'This sign-in link is invalid or has expired. Please go back to OPS and try again.',
      go_to_sign_in: 'Go to sign in',
      signing_in: 'Signing you in…',
    },
    team_invite: {
      title: 'Clinic team invitation',
      clinic_fallback: 'the clinic',
      invalid: 'This invitation link is invalid.',
      expired: 'This invitation has expired. Please ask the clinic to send a new one.',
      go_to_sign_in: 'Go to sign in',
      joined: 'You have joined %{clinic}. Taking you to the portal…',
      intro:
        "%{clinic} is inviting your account (%{email}) to join their clinic team. If you accept, the clinic's master account will be able to see the patients your account manages. Your login, password and patients stay exactly as they are.",
      confirm_it_is_you: "Sign in to confirm it's you:",
      email: 'Email',
      password: 'Password',
      accept: 'Accept & join team',
      decline: 'Decline',
      forgot_before: 'Forgot your password? Open the',
      forgot_link: 'password reset page',
      forgot_after: 'first, then use this invitation link again.',
      sign_in_failed: 'Sign-in failed. Please check your password.',
      accept_failed: 'Could not accept the invitation.',
      generic_error: 'Something went wrong. Please try again.',
    },
    // Tooltip on the app bar's loading indicator.
    app_bar: {
      last_updated: 'Last updated: %{time}',
      no_data_loaded: 'No data loaded yet',
    },
    weight_history: {
      title: 'Weight History',
      current: 'Current weight: %{weight}',
      recent_entries: 'Recent Entries:',
      showing_latest: 'Showing latest 5 of %{count} entries',
      series: 'Weight',
    },
    daily_trend: {
      avg: 'Daily Avg:',
      nadir: 'Daily Nadir:',
      peak: 'Daily Peak:',
      readings: '%{count} readings',
    },
    // Chronic-state banner on the patient page. The title and the one-line clinical
    // summary are built from these (utils/tirStats.ts returns the key + numbers).
    glycemic_control: {
      based_on: '(based on %{count} readings)',
      controlled: { title: 'In target range' },
      insufficient_data: { title: 'Insufficient data for chronic-state evaluation' },
      uncontrolled_high: { title: 'Chronic hyperglycemia' },
      uncontrolled_low: { title: 'Chronic hypoglycemia' },
      mixed: { title: 'Uncontrolled — wide glucose swings' },
      summary: {
        controlled: 'In target %{tir}% of readings',
        insufficient_data: 'Not enough readings to evaluate chronic state',
        uncontrolled_high: 'Above target %{tar}% of readings (sustained hyperglycemia)',
        uncontrolled_low:
          'Below target %{tbr}% of readings (sustained hypoglycemia — clinically urgent)',
        mixed: 'Above target %{tar}% AND below target %{tbr}% — wide swings',
      },
    },
    common: {
      empty_data: '—',
      add_note: 'Add Note',
      not_available: 'N/A',
      clear: 'Clear',
      unknown_error: 'Unknown error',
      close: 'Close',
      clear_search: 'Clear search',
      pet_fallback: 'Pet #%{id}',
      group_fallback: 'Group %{id}',
      user_fallback: 'User %{id}',
      vet_fallback: 'Vet #%{id}',
    },
    owners: {
      title: 'Clients',
      total_count: 'Total: %{count} clients',
      total_summary: 'Total: %{count} clients · %{active} active · %{pending} pending',
      pets_count: 'Pets',
      devices_count: 'Devices',
      status: 'Status',
      status_active: 'Active',
      status_pending: 'Pending',
      status_disabled: 'Disabled',
      no_owners_yet: 'No clients have been created yet.',
      select_owner: 'Select a client to view their patients and devices',
      phone: 'Phone',
      created: 'Created',
      invitation_label: 'Invitation',
      invitation_awaiting: 'Awaiting client confirmation',
      invitation_sent_on: 'Invitation sent %{date} · awaiting confirmation',
      invitation_confirmed: 'Confirmed',
      no_pets_yet: 'No pets created for this client yet.',
      no_devices_yet: 'No devices linked yet.',
      device_active: 'Active',
      device_inactive: 'Not activated',
      resend_invite: 'Resend Invite',
      resend_success: 'Invitation email re-sent to the client.',
      resend_already_active: 'This client has already confirmed their account.',
      resend_rate_limited: 'Too many resend attempts. Please try again later.',
      resend_error: 'Could not resend the invitation. Please try again.',
    },
    leads: {
      title: 'Adapet Leads 2026',
      subtitle:
        'Combined event leads imported from VMX, WVC, and Fetch Charlotte email attachments.',
      total_records: 'Total leads',
      unique_emails: 'Unique emails',
      sources: 'Lead sources',
      filtered_records: 'Filtered results',
      search_placeholder: 'Search by lead, company, email, role, or source',
      all_events: 'All events',
      empty_state: 'No leads match the current filters.',
      access_denied: 'Only site administrators can view imported marketing leads.',
    },
    shares: {
      share_created_successfully: 'Share created successfully',
      share_revoked_successfully: 'Share revoked successfully',
      share_creation_failed: 'Some shares failed to create. Please try again.',
      unexpected_error: 'An unexpected error occurred',
      create: {
        title: 'Create New Share',
        step_recipient: 'Choose Recipient',
        step_pets: 'Select Pets',
        step_permissions: 'Set Permissions',
        how_to_share: 'How would you like to share?',
        share_registered: 'Share with registered veterinarians',
        invite_email: 'Invite new veterinarians by email',
        select_veterinarians: 'Select Veterinarians',
        search_vets_placeholder: "Search by name or email (e.g., 'Dr. Smith' or 'vet@clinic.com')",
        vet_email_n: 'Veterinarian Email %{n}',
        vet_email_placeholder: 'colleague@vetclinic.com',
        invite_helper: "We'll send them an invitation to join the platform",
        add_another_email: 'Add Another Email',
        what_to_share: 'What would you like to share?',
        all_pets: 'All patients in my care',
        all_pets_hint: 'Share all current and future pets in your care',
        specific_pets: 'Specific pets only',
        specific_pets_hint: 'Choose exactly which pets to share',
        select_pets: 'Select Pets',
        select_pets_placeholder: 'Choose pets to share',
        what_can_they_do: 'What can they do?',
        perm_view_metrics: 'View glucose metrics and charts',
        perm_view_emrs: 'View electronic medical records',
        perm_add_activities: 'Add activities (insulin, food, exercise)',
        perm_add_emr_notes: 'Add notes to medical records',
        note_label: 'Note (Optional)',
        note_placeholder: "Add a message about why you're sharing...",
        expiration_label: 'Expiration Date (Optional)',
        expiration_hint: 'Leave blank for no expiration',
        cancel: 'Cancel',
        back: 'Back',
        next: 'Next',
        send_invitations: 'Send Invitations',
        create_shares: 'Create Shares',
        error_no_vets: 'Please select at least one veterinarian to share with',
        error_no_emails: 'Please enter at least one email address to invite',
        created_success:
          'Successfully created %{smart_count} share |||| Successfully created %{smart_count} shares',
        create_failed: 'Failed to create shares: %{error}',
        partial_failure: '%{success} share(s) created, but %{failed} failed: %{error}',
      },
    },
    clinic_team: {
      title: 'Clinic Team',
      subtitle:
        'Add a sub-account for each veterinarian, then assign patients so their alerts go to the responsible vet. Sub-accounts are optional — you can keep managing everything from this master account.',
      add_button: 'Add Sub-Account',
      empty: 'No team members yet. Add a sub-account to get started.',
      list_unavailable: 'Your team list will appear here once sub-accounts are added.',
      sub_account_notice:
        'Only your clinic’s master account can manage the team. Ask them to add, disable, or reassign veterinarians for you.',
      col_name: 'Name',
      col_email: 'Email',
      col_title: 'Title',
      col_status: 'Status',
      col_alerts: 'Alerts',
      col_actions: 'Actions',
      action_resend: 'Resend Invite',
      action_disable: 'Disable',
      action_enable: 'Enable',
      action_view_patients: 'View Patients',
      invite_resent: 'Invitation re-sent.',
      disabled: 'Sub-account disabled.',
      disabled_reassign:
        'Sub-account disabled. %{count} patient(s) are still assigned to it — reassign them to another vet.',
      enabled: 'Sub-account re-enabled.',
      status_active: 'Active',
      status_pending_invitation: 'Pending Invitation',
      status_disabled: 'Disabled',
      status_removed: 'Removed',
      alerts_on: 'On',
      alerts_off: 'Off',
      add_title: 'Add Sub-Account',
      add_description:
        'Create a veterinarian sub-account. They sign in with their own email and see the patients linked to them — those they registered, those whose owners chose them, and any shared with them — not the whole clinic. Assigning a patient to them routes its alerts; it does not change who can see it. This master account sees everything its sub-accounts see.',
      add_submit: 'Create Sub-Account',
      first_name: 'First Name',
      last_name: 'Last Name',
      email: 'Email',
      professional_title: 'Title / Role',
      phone: 'Phone (optional)',
      allow_alerts: 'Receive alert emails for their patients',
      send_invite: 'Send activation invite now',
      created_invited: 'Sub-account created — an activation invite was sent to %{email}.',
      created_no_invite: 'Sub-account created for %{email}. You can send the invite later.',
      assign_action: 'Assign vet',
      reassign_action: 'Reassign',
      assign_title: 'Assign responsible veterinarian',
      assign_description:
        'Tick every vet who is responsible for %{pet}. Each of them receives its alerts; ticking nobody leaves the patient — and its alerts — with the master account.',
      assigned_vet: 'Responsible veterinarian',
      unassigned: 'Unassigned (master account)',
      unassigned_short: 'Unassigned',
      view_patients_chip: 'Assigned to: %{vet}',
      no_assigned_patients:
        'No patients are assigned to this veterinarian yet. Use Assign vet on a patient row to make them responsible.',
      assign_to_me: 'Me (master account)',
      assign_alerts_off: 'email alerts off',
      assign_muted_warning:
        'This veterinarian has email alerts turned off, so NO ONE will be emailed about this patient — not you, not the clinic. Turn their alerts on, or choose someone else.',
      assigned_vets: 'Responsible veterinarians',
      assign_muted_warning_for:
        '%{vet} has email alerts turned off, so they will not be emailed about this patient. If no one else receives alerts, NO ONE will be emailed — not you, not the clinic. Turn their alerts on, or choose someone else.',
      history_action: 'History',
      history_title: 'Assignment history',
      history_empty: 'No assignment changes recorded for this patient.',
      history_error: 'Could not load the assignment history.',
      history_when: 'When',
      history_by: 'Changed by',
      history_before: 'Before',
      history_after: 'After',
      history_system: 'System',
      mute_label: 'Email me alerts for this patient',
      mute_error: 'Could not update your alert setting for this patient.',
      mute_silenced_warning:
        'No one is set to be emailed about this patient: every recipient has muted it or has email alerts off.',
      assign_submit: 'Save',
      assign_success: 'Patient assignment updated.',
      assign_not_in_team: 'That veterinarian is not part of your clinic team.',
      reminder_text:
        '%{count} patient(s) are not assigned to a veterinarian. Assign them so their alerts reach the responsible vet.',
      reminder_assign: 'Assign patients',
      reminder_later: 'Remind me in 7 days',
      reminder_turn_off: 'Turn off reminders',
      reminder_turned_off: 'Patient-assignment reminders turned off.',
      error_name_required: 'First and last name are required.',
      error_email_invalid: 'Please enter a valid email address.',
      error_email_exists: 'An account with this email already exists.',
      invite_existing_prompt:
        'Want to bring the existing account %{email} into your clinic team instead? We will email them an invitation — nothing changes until they accept.',
      invite_existing_button: 'Send team invitation',
      invite_existing_sent: 'Invitation sent to %{email}. They join your team once they accept.',
      error_generic: 'Could not create the sub-account. Please try again.',
      error_network: 'Network error. Please check your connection and try again.',
    },
    pet_shares: {
      title: 'Pet Shares',
      subtitle:
        'Share patient records with other veterinarians for collaboration and better care. You can share all patients or select specific cases.',
      edit_title: 'Edit Share',
      edit_permissions: 'Permissions',
      edit_expiry: 'Expiration date',
      edit_expiry_hint: 'Leave empty for no expiration',
      edit_note: 'Note',
      save: 'Save Changes',
      share_updated: 'Share updated',
      error_no_permissions: 'Select at least one permission.',
      error_update_failed: 'Failed to update the share. Please try again.',
      resend_invite: 'Resend invitation email',
      invite_resent: 'Invitation email re-sent',
      copy_link: 'Copy invite link',
      link_copied: 'Invite link copied to clipboard',
      selected_count: '%{count} selected',
      revoke_selected: 'Revoke Selected',
      bulk_revoked: '%{count} share(s) revoked',
      decline: 'Decline',
      decline_confirm:
        'Decline this share? You will lose access to these pets and the sharer will see it as declined.',
      share_declined: 'Share declined',
      revoke_confirm: 'Are you sure you want to revoke this share?',
      revoke_share: 'Revoke Share',
      resend_failed: 'Failed to resend the invitation',
      bulk_revoke_confirm: 'Revoke %{count} selected share(s)?',
      bulk_revoke_failed: 'Bulk revoke failed',
      revoke_failed: 'Failed to revoke share',
      // Per-row icon buttons: the id keeps otherwise identical buttons distinguishable.
      aria: {
        edit: 'edit share %{id}',
        resend: 'resend invite %{id}',
        copy: 'copy invite link %{id}',
        revoke: 'revoke share %{id}',
      },
      bulk_revoked_partial: '%{count} share(s) revoked (%{failed} failed)',
      decline_failed: 'Failed to decline the share',
      load_failed: 'Failed to load shares. Please try again later.',
      empty_title: 'No shares yet',
      empty_subtitle: 'Create your first share to collaborate with other veterinarians.',
      create_share: 'Create Share',
      tab_my_shared: 'My Shared Pets',
      tab_shared_with_me: 'Shared With Me',
      status_active: 'Active',
      status_pending: 'Pending Invitation',
      status_accepted: 'Accepted',
      status_declined: 'Declined',
      chip_n_pets: '%{smart_count} Pet |||| %{smart_count} Pets',
      permissions_summary: 'Permissions: %{list}',
      created_label: 'Created: %{date}',
    },
    clinic_profile_prompt: {
      title: 'Complete your clinic profile',
      subtitle:
        'Your account does not have your clinic details on file yet. Add them once and we will start verifying your clinic — verification unlocks clinic pricing and ordering.',
      field_professional_title: 'Your professional title',
      professional_title_placeholder: 'e.g. DVM, Practice Manager, Vet Tech',
      field_practice_type: 'Practice type',
      practice_type_general: 'General practice',
      practice_type_emergency: 'Emergency clinic',
      practice_type_specialty: 'Specialty / referral hospital',
      practice_type_mobile: 'Mobile practice',
      practice_type_other: 'Other',
      field_number_of_vets: 'Number of full-time veterinarians',
      terms:
        'I confirm I am a licensed veterinary professional and the details above are accurate.',
      submit: 'Submit for verification',
      submitting: 'Submitting…',
      skip: 'Not now',
      success: 'Thanks — your clinic has been submitted for verification.',
      error_generic: 'Could not submit your clinic details. Please try again.',
      validation_required: 'Please fill in every required field.',
      validation_terms: 'Please confirm the details above are accurate.',
    },
    onboarding_share: {
      title: 'Share your practice with colleagues',
      subtitle:
        'Invite colleagues to collaborate on your patients. They will get access to all your pets and clients — including ones you add later. You can revoke access anytime from Pet Shares.',
      emails: 'Colleague emails',
      emails_placeholder: 'colleague1@clinic.com, colleague2@clinic.com',
      hint: 'Separate multiple addresses with commas.',
      submit: 'Send Invitations',
      skip: 'Skip for now',
      done: '%{count} invitation(s) sent.',
      failed_list: 'Could not invite: %{emails}',
      error_invalid: 'Please enter one or more valid email addresses.',
    },
    register_owner: {
      title: 'Add New Client',
      subtitle:
        'Create an account for a client during their clinic visit. They will receive an email to set their password and activate it.',
      owner_name: 'Client name',
      owner_email: 'Client email',
      owner_phone: 'Phone (optional)',
      add_pet: 'Also register their pet',
      pet_name: 'Pet name',
      pet_species: 'Species',
      pet_breed: 'Breed',
      pet_dob: 'Date of birth',
      add_note: 'Document this visit (clinical note)',
      note_text: 'Visit note',
      submit: 'Add Client',
      success_title: 'Client registered',
      success_owner: '%{name} (%{email}) has been registered.',
      success_pet: 'Pet "%{name}" was added to their account.',
      email_sent: 'An account activation email was sent to %{email}.',
      email_failed:
        'The account was created, but the activation email could not be sent. You can re-send it later.',
      register_another: 'Add Another Client',
      view_owners: 'View Clients',
      owner_exists:
        'This email belongs to an existing account that cannot be registered as a client.',
      approval_title: 'Client approval requested',
      approval_body:
        'This email already has an AdaPet account, so nothing was changed yet. The client has been asked to approve adding you as their veterinarian (and the pet, if provided).',
      approval_email_sent:
        'An approval email was sent to the client. The request expires in 30 days.',
      approval_email_failed:
        'The request was recorded, but the approval email could not be sent. Ask the client to check later or contact support.',
      approval_pending:
        'You already have a pending request for this client. They need to approve it from their email.',
      already_linked: 'You are already associated with this client and no pet was requested.',
      not_authorized: 'Only veterinarians can register clients.',
      error_name_required: 'Client name is required (at least 2 characters).',
      error_email_invalid: 'Please enter a valid email address.',
      error_note_empty: 'The visit note must not be empty.',
      error_generic: 'Failed to register the client. Please try again.',
      error_network: 'Network error. Please check your connection and try again.',
    },
    profile: {
      title: 'Profile',
      profile_with_info: 'Profile: %{name} (ID: %{id})',
      my_profile: 'My Profile',
      edit_profile: 'Edit Profile',
      name: 'Name',
      id: 'ID',
      email: 'Email',
      phone: 'Phone',
      clinic: 'Clinic',
      field_clinic_name: 'Clinic Name',
      field_address: 'Address',
      field_postal_code: 'ZIP / Postal Code',
      field_city: 'City',
      field_state: 'State / Province',
      field_country: 'Country',
      country_us: 'United States',
      country_ca: 'Canada',
      validation_state_invalid: 'Please provide a valid state or province',
      field_short_description: 'Short Description',
      field_full_profile: 'Full Profile',
      placeholder_short_description: 'Brief description of your clinic services',
      placeholder_full_profile:
        'Detailed description of your veterinary practice, services, and expertise',
      not_set: 'Not set',
      qr_code: 'QR Code',
      qr_code_clinic_label: 'Clinic code for pet owners: %{id}',
      glucose_unit: 'Glucose Unit',
      glucose_unit_mmol: 'mmol/L',
      glucose_unit_mgdl: 'mg/dL',
      validation_name_required: 'Name is required',
      validation_phone_invalid: 'Please provide a valid phone number (10-15 digits)',
      validation_postal_invalid: 'Please provide a valid ZIP or postal code',
      profile_updated: 'Profile updated successfully',
      profile_update_failed: 'Failed to update profile',
      glucose_unit_saved: 'Glucose unit preference saved',
      glucose_unit_save_failed: 'Failed to save glucose unit preference',
      cancel: 'Cancel',
      save: 'Save',
      saving: 'Saving...',
      print: 'Print',
      ok: 'OK',
    },
    key_findings: {
      title: 'Key Clinical Findings',
      severity: {
        high: 'High',
        medium: 'Medium',
        info: 'Info',
      },
      review_label: 'Vet should review',
      low_glucose: {
        title_significant: 'Low glucose readings may require review',
        title_detected: 'Low glucose readings recorded',
        what_significant:
          '%{count} reading(s) fell below %{threshold} %{unit} during the selected report period (time below range %{tbr}%).',
        what_detected:
          'Readings below the target range (%{threshold} %{unit}) were recorded during the selected report period (time below range %{tbr}%).',
        why: 'Low glucose readings may represent a patient-safety concern and should be reviewed with insulin, meal, and clinical context.',
        review:
          'Review the timing of low readings against insulin administration and meals; confirm with blood glucose testing.',
        related: 'See Low Glucose Events',
        related_pdf: 'See Page 6: Events & Notes',
      },
      no_low_events: {
        title: 'No low glucose events detected',
        what: 'No readings below the low threshold (%{threshold} %{unit}) were detected during the selected report period.',
        why: 'This applies only to recorded data within the selected window and does not rule out hypoglycemia outside it.',
        review:
          'Confirm with blood glucose testing if clinical signs suggest hypoglycemia or readings do not match the clinical presentation.',
        related: 'See Low Glucose Events',
        related_pdf: 'See Page 6: Events & Notes',
      },
      data_quality: {
        title_adequate: 'Data coverage adequate for selected period',
        title_moderate: 'Data quality moderate for selected period',
        title_limited: 'Data quality limited for selected period',
        title_poor: 'Limited data quality for selected period',
        what: 'Data coverage was %{coverage}% from %{start} to %{end} (%{readings} readings).',
        why_adequate: 'Findings should be interpreted within this selected report period only.',
        why_low:
          'Gaps in sensor data reduce confidence in pattern interpretation and may miss high or low readings.',
        review_adequate: 'Interpret findings within the selected report period only.',
        review_low:
          'Review sensor placement and consider extending monitoring if clinically appropriate.',
        related: 'See Daily Metrics',
        related_pdf: 'See Daily Overview section',
      },
      owner_events_missing: {
        title: 'Client activity records are missing',
        what: 'No insulin, meal, medication, symptom, or activity events were recorded during the selected report period.',
        why: 'Without client-recorded context, glucose changes cannot be linked to insulin timing, meals, or clinical events.',
        review:
          'Ask the client to record insulin, meals, medications, and symptoms during the next monitoring period.',
        related: 'See Daily Trends & Activities',
        related_pdf: 'See Page 5: Daily Trends',
      },
      tar: {
        title_predominant: 'Predominant hyperglycemia',
        title_elevated: 'Elevated above-target glucose exposure',
        title_moderate: 'Moderate above-target glucose exposure',
        what: 'Time above range was %{tar}% during the selected report period.',
        why: 'Sustained above-target glucose may indicate inadequate glycemic control during the recorded window.',
        review:
          'Review insulin timing, dose schedule, meal timing, client compliance, and concurrent illness.',
        related: 'See Glucose Trend & Daily TIR',
        related_pdf: 'See Page 2: Glucose Trend & Page 3: Daily Overview',
      },
      tir: {
        title_majority: 'Majority of time in target range',
        title_moderate: 'Moderate time in target range',
        title_limited: 'Limited time in target range',
        title_very_limited: 'Very limited time in target range',
        what: 'Time in target range was %{tir}% using the selected target range of %{min}-%{max} %{unit}.',
        why: 'Time in range summarizes overall glycemic control across the selected report period.',
        review:
          'Compare against previous monitoring periods and the treatment goals for this patient.',
        related: 'See Daily TIR',
        related_pdf: 'See Page 3: Daily Overview',
      },
      variability: {
        title: 'High glucose variability',
        what: 'CV was %{cv}% and standard deviation was %{sd} %{unit} during the selected report period.',
        why: 'High variability suggests substantial glucose fluctuation, which can reflect inconsistent routine or missed events.',
        review: 'Review meal consistency, insulin timing, activity, and client compliance.',
        related: 'See AGP & Daily Trends',
        related_pdf: 'See Page 4: AGP & Page 5: Daily Trends',
      },
      peak_nadir: {
        title: 'Peak glucose reached %{peak} %{unit}',
        what: 'The highest recorded glucose was %{peak} %{unit} (%{peakTime}); the lowest was %{nadir} %{unit} (%{nadirTime}).',
        why: 'Extremes mark the bounds of glycemic exposure during the selected report period.',
        why_no_events:
          'No client-recorded insulin or meal events were available to interpret these extremes.',
        review:
          'Review the timing of the peak and nadir against insulin administration, meals, and client notes.',
        related: 'See Glucose Trend',
        related_pdf: 'See Page 2: Glucose Trend',
      },
    },
    cgm_insights: {
      title: 'Key CGM Data Insights for Veterinary Review',
      subtitle: 'Adjunctive CGM Data · For Veterinary Review',
      summary_label: 'Selected Period Data Summary',
      disclaimer:
        'For veterinary review only. CGM data are supportive monitoring data and should be interpreted with clinical signs, patient history, insulin and meal records, client notes, and confirmatory blood glucose testing when appropriate. Diagnosis and treatment decisions remain the responsibility of the attending veterinarian.',
      review_prefix: 'For Veterinary Review',
      see_prefix: 'See',
      // Rendered next to a headline number that counts readings, so it can't be
      // misread as a glucose value (Faithfull Friends CR, 2026-08-18).
      readings_suffix: 'readings',
      groups: {
        needs_review: 'Needs Review',
        needs_review_subtitle: 'Data patterns that may warrant veterinary review.',
        monitoring: 'Monitoring Context',
        data_quality: 'Data Quality',
      },
      summary: {
        lead: 'During the selected report period, patient %{pet}’s CGM data showed ',
        lead_generic: 'During the selected report period, CGM data showed ',
        tar_moderate: 'moderate above-target glucose exposure',
        tar_high: 'high above-target glucose exposure',
        variability_high: 'high glucose variability',
        peak: 'one sensor-recorded glucose peak above %{peak} %{unit}',
        no_low: 'No low glucose readings were recorded during this period.',
        low: '%{count} sensor-recorded low reading(s) below %{threshold} %{unit} were recorded during this period.',
        coverage_adequate: 'Data coverage was adequate',
        coverage_limited: 'Data coverage was limited',
        days_limited: ', but interpretation is limited to %{days} active data days.',
        days_ok: '.',
      },
      tar: {
        title: 'Above-target glucose exposure',
        key_label: 'Above selected target range',
        meaning:
          'Glucose was above the selected target range for %{tar}% of the selected report period.',
        review:
          'Review insulin schedule, meal timing, client compliance, concurrent illness, and related client notes.',
        see: 'Glucose Trend / Daily TIR',
      },
      peak: {
        title: 'Sensor-recorded glucose peak above %{peak} %{unit}',
        key_label: '%{unit} · Sensor-recorded peak',
        sub_label: 'Time of peak',
        meaning: 'This was the highest sensor-recorded glucose value during the selected period.',
        review:
          'Compare peak timing with insulin administration, meals, clinical signs, client notes, and confirmatory blood glucose testing if clinically indicated.',
        see: 'Glucose Trend',
      },
      variability: {
        title: 'High glucose variability pattern',
        key_label: 'CV',
        sub_label: 'SD',
        meaning: 'Glucose values fluctuated substantially during the selected period.',
        review:
          'Review meal consistency, insulin timing, activity level, missed events, and client-recorded context.',
        see: 'AGP / Daily Trends',
      },
      low_glucose: {
        title: 'Low glucose readings recorded',
        key_label: 'below %{threshold} %{unit}',
        meaning:
          'Sensor-recorded readings below the target range were detected during the selected period.',
        review:
          'Compare the timing of low readings with insulin administration and meals; confirm with blood glucose testing.',
        see: 'Low Glucose Events',
      },
      owner_events_missing: {
        title: 'No client-recorded events',
        key_label: 'Client events recorded',
        meaning:
          'No insulin, meal, medication, symptom, or activity events were recorded during the selected period.',
        review:
          'Ask the client to record insulin, meals, medications, symptoms, and relevant activity during the next monitoring period.',
        see: 'Daily Trends & Activities',
      },
      tir: {
        title: 'Time in target range',
        key_label: 'Within %{min}–%{max} %{unit}',
        meaning:
          'Time in range summarizes glucose exposure within the selected target range during this report period.',
        review:
          'Interpret together with high/low exposure, variability, clinical signs, and patient-specific goals set by the veterinarian.',
        see: 'Daily TIR',
      },
      no_low_events: {
        title: 'No low glucose readings recorded',
        key_label: 'below %{threshold} %{unit}',
        meaning:
          'No sensor-recorded readings below %{threshold} %{unit} were recorded during this selected window. This does not rule out hypoglycemia outside the recorded period or symptoms not captured by CGM data.',
        review:
          'Confirm with blood glucose testing if clinical signs suggest hypoglycemia or if CGM readings do not match the patient’s condition.',
        see: 'Low Glucose Events',
      },
      data_quality: {
        title: 'Data coverage adequate',
        title_limited: 'Data coverage limited',
        key_label: 'Coverage · %{readings} readings',
        sub_label: 'Active data days',
        days_value: '%{days} days',
        meaning: 'Findings should be interpreted only within the selected report period.',
      },
    },
    reports: {
      export_csv: 'Export CSV',
      truncated_warning:
        'Not all readings in this range could be loaded — the export may be incomplete. Narrow the date range for complete data.',
      csv_load_error:
        'Could not load the readings for this range — the export is unavailable. Reload the page or try again.',
      daily_glucose_range: 'Daily Glucose Range',
      daily_glucose_lines: 'Daily Glucose Lines',
      daily_glucose_histograms: 'Daily Glucose Histograms',
      combined_glucose_histogram: 'Combined Glucose Histogram',
      axis_labels: {
        glucose: 'Glucose',
        date: 'Date',
        time_of_day: 'Time of Day',
        count: 'Count',
      },
      chart_series: {
        daily_glucose: 'Daily Glucose',
        daily_avg: 'Daily Avg',
      },
      hover_labels: {
        min: 'Min',
        max: 'Max',
        avg: 'Avg',
      },
    },
    metrics: {
      filters: {
        device: 'Device',
        timestamp_gte: 'Timestamp ≥',
        timestamp_lte: 'Timestamp ≤',
        glucose_gte: 'Glucose ≥',
        glucose_lte: 'Glucose ≤',
      },
    },
  },
  resources: {
    customers: {
      name: 'Customer |||| Customers',
      fields: {
        orders: 'Orders',
        first_seen: 'First seen',
        full_name: 'Name',
        groups: 'Segments',
        last_seen: 'Last seen',
        last_seen_gte: 'Visited Since',
        name: 'Name',
        total_spent: 'Total device spend',
        password: 'Password',
        confirm_password: 'Confirm password',
        stateAbbr: 'State',
      },
      filters: {
        last_visited: 'Last visited',
        today: 'Today',
        this_week: 'This week',
        last_week: 'Last week',
        this_month: 'This month',
        last_month: 'Last month',
        earlier: 'Earlier',
        has_ordered: 'Has ordered',
        has_newsletter: 'Has newsletter',
        group: 'Segment',
      },
      fieldGroups: {
        identity: 'Identity',
        address: 'Address',
        stats: 'Stats',
        history: 'History',
        password: 'Password',
        change_password: 'Change Password',
      },
      page: {
        delete: 'Delete Customer',
      },
      errors: {
        password_mismatch: 'The password confirmation is not the same as the password.',
      },
      notifications: {
        created: 'Customer created |||| %{smart_count} customers created',
        updated: 'Customer updated |||| %{smart_count} customers updated',
        deleted: 'Customer deleted |||| %{smart_count} customers deleted',
      },
    },
    groups: {
      name: 'Care Team |||| Care Teams',
      fields: {
        name_helper: 'Choose a unique name for your veterinary group',
        description_helper: 'Describe the purpose of this group (optional)',
      },
      notifications: {
        created: 'Group created successfully',
        updated: 'Group updated successfully',
        consent_update_failed: 'Failed to update consent',
        members_load_failed: 'Failed to load members',
        email_required: 'Please enter an email address',
        group_id_missing: 'Group ID is missing',
        invite_failed: 'Failed to send invitation',
        member_removed: 'Member removed successfully',
        member_remove_failed: 'Failed to remove member',
      },
      errors: {
        forbidden: 'You do not have permission to perform this action',
        create_failed: 'Failed to create group. Please try again.',
        no_create_permission:
          'You do not have permission to create groups. Only veterinary administrators can create groups.',
      },
      ui: {
        invitations: 'Group Invitations',
        // Shown instead of react-admin's default empty state to anyone who
        // cannot create a Care Team — which is every role but vetadmin.
        empty_title: 'No Care Teams yet.',
        empty_readonly:
          'Your clinic doesn’t need a Care Team. Your clinic manages its own vets in Clinic Team, and shares patients with a colleague in Pet Shares.',
        empty_use_clinic_team:
          'Add a sub-account for each vet and assign patients so their alerts reach the responsible vet, under',
        invitation_pending: 'Group Invitation Pending',
        invitation_pending_desc:
          'You have been invited to join this group. Please accept or decline.',
        accept: 'Accept',
        decline: 'Decline',
        declined: 'Declined',
        cancel: 'Cancel',
        administrators: 'Administrators',
        unknown: 'Unknown',
        loading: 'Loading...',
        invite_member: 'Invite Member',
        invite_new_member: 'Invite New Member',
        email_address: 'Email Address',
        remove_member_confirm: 'Are you sure you want to remove this member?',
        group_members: 'Group Members',
        read_only: '(Read-Only)',
        send_invitation: 'Send Invitation',
        sending: 'Sending...',
        col_group: 'Group',
        col_invited_by: 'Invited By',
        col_invited_date: 'Invited Date',
        col_invited_at: 'Invited At',
        col_status: 'Status',
        col_actions: 'Actions',
        col_email: 'Email',
        col_user: 'User',
      },
    },
    orders: {
      name: 'Order |||| Orders',
      amount: '1 order |||| %{smart_count} orders',
      title: 'Order %{reference}',
      fields: {
        basket: {
          delivery: 'Delivery',
          reference: 'Reference',
          quantity: 'Quantity',
          sum: 'Sum',
          tax_rate: 'Tax Rate',
          taxes: 'Tax',
          total: 'Total',
          unit_price: 'Unit Price',
        },
        address: 'Address',
        customer_id: 'Customer',
        date_gte: 'Passed Since',
        date_lte: 'Passed Before',
        nb_items: 'Number of Items',
        total_gte: 'Min amount',
        status: 'Status',
        returned: 'Returned',
      },
      section: {
        order: 'Order',
        customer: 'Customer',
        shipping_address: 'Shipping Address',
        items: 'Items',
        total: 'Totals',
      },
      notifications: {
        created: 'Order created |||| %{smart_count} orders created',
        updated: 'Order updated |||| %{smart_count} orders updated',
        deleted: 'Order deleted |||| %{smart_count} orders deleted',
      },
    },
    invoices: {
      name: 'Invoice |||| Invoices',
      fields: {
        date: 'Invoice date',
        customer_id: 'Customer',
        order_id: 'Order',
        date_gte: 'Passed Since',
        date_lte: 'Passed Before',
        total_gte: 'Min amount',
        address: 'Address',
      },
      notifications: {
        created: 'Invoice created |||| %{smart_count} invoices created',
        updated: 'Invoice updated |||| %{smart_count} invoices updated',
        deleted: 'Invoice deleted |||| %{smart_count} invoices deleted',
      },
    },
    products: {
      name: 'Poster |||| Posters',
      fields: {
        category_id: 'Category',
        height_gte: 'Min height',
        height_lte: 'Max height',
        height: 'Height',
        image: 'Image',
        price: 'Price',
        reference: 'Reference',
        sales: 'Sales',
        stock_lte: 'Low Stock',
        stock: 'Stock',
        thumbnail: 'Thumbnail',
        width_gte: 'Min width',
        width_lte: 'Max width',
        width: 'Width',
      },
      tabs: {
        image: 'Image',
        details: 'Details',
        description: 'Description',
        emrs: 'EMRs',
      },
      filters: {
        categories: 'Categories',
        stock: 'Stock',
        no_stock: 'Out of stock',
        low_stock: '1 - 9 items',
        average_stock: '10 - 49 items',
        enough_stock: '50 items & more',
        sales: 'Sales',
        best_sellers: 'Best sellers',
        average_sellers: 'Average',
        low_sellers: 'Low',
        never_sold: 'Never sold',
      },
      notifications: {
        created: 'Poster created |||| %{smart_count} posters created',
        updated: 'Poster updated |||| %{smart_count} posters updated',
        deleted: 'Poster deleted |||| %{smart_count} posters deleted',
      },
    },
    categories: {
      name: 'Category |||| Categories',
      fields: {
        products: 'Products',
      },
      notifications: {
        created: 'Category created |||| %{smart_count} categories created',
        updated: 'Category updated |||| %{smart_count} categories updated',
        deleted: 'Category deleted |||| %{smart_count} categories deleted',
      },
    },
    owners: {
      name: 'Client |||| Clients',
      amount: '1 client |||| %{smart_count} clients',
    },
    leads: {
      name: 'Lead |||| Leads',
      amount: '1 lead |||| %{smart_count} leads',
      fields: {
        event: 'Event',
        name: 'Lead',
        email: 'Email',
        company: 'Company',
        role: 'Role',
        location: 'Location',
        context: 'Context',
        captured_at: 'Captured At',
      },
    },
    pets: {
      // Clinic filter on the Pets list (internal / support view).
      clinic_filter: {
        chip: 'Clinic: %{name}',
        best_effort: 'Showing best-effort match instead.',
        load_failed: 'Failed to load linked pets.',
        mismatch_title: 'Data mismatch detected',
        mismatch_body:
          'Clinic shows %{linked} linked pet(s), but only %{found} pet record(s) found. This usually means a linked pet was archived or its access policy hides it from this view. Check the Pet ID list with support.',
        sources:
          'Sources: direct=%{direct}, vets-link=%{vets}, clinic-share=%{share}, pet-share=%{specific}',
        none_linked: 'No pets linked to this clinic.',
      },
      // Chronic-condition choices on the pet edit form (the stored value is the code).
      conditions: {
        diabetes: 'Diabetes mellitus',
        kidney_disease: 'Chronic kidney disease',
        hyperthyroidism: 'Hyperthyroidism',
        hypothyroidism: 'Hypothyroidism',
        obesity: 'Obesity',
        arthritis: 'Osteoarthritis',
        heart_disease: 'Heart disease',
        cushings: "Cushing's disease",
        addisons: "Addison's disease",
        epilepsy: 'Epilepsy',
        other: 'Other',
      },
      name: 'Pet |||| Pets',
      amount: '1 pet |||| %{smart_count} pets',
      detail: 'Pet detail',
      search_placeholder: 'Search by Pet Name / Client / Breed / Species / ID',
      fields: {
        id: 'Id',
        name: 'Pet Name',
        owner: 'Client',
        co_owners: 'App users',
        pet_name: 'Pet Name',
        dob: 'DoB',
        birthday: 'Birthday',
        created: 'Created',
        owner_email: 'Client Email',
        owner_website: 'Client Website',
        species: 'Species',
        breed: 'Breed',
        height: 'Height',
        weight: 'Weight',
        sex: 'Sex',
        color: 'Color',
        createdAt: 'Created',
        updatedAt: 'Updated',
        sensor_activated: 'Sensor Activated',
        vet_account: 'Vet Account',
        vet_account_not_bound: 'Not bound to vet account',
        assigned_vet: 'Responsible Vet',
        data_status: 'Data Status',
        weight_kg: 'Weight (kg, exact)',
        neutered: 'Neutered / Spayed',
        hide_glucose_values: 'Hide glucose numbers from owner',
        birth_date: 'Birth date (exact)',
        body_condition_score: 'Body condition score (1-9)',
        chronic_conditions: 'Chronic conditions',
        condition_code: 'Condition',
        condition_diagnosed_on: 'Diagnosed on',
        condition_notes: 'Notes',
        target_glucose_low: 'Target glucose low (mg/dL)',
        target_glucose_high: 'Target glucose high (mg/dL)',
        target_kcal_in_override: 'Vet kcal target (kcal/day, optional override)',
      },
      data_status: {
        active: 'Active',
        waiting_sync: 'Waiting Sync',
        no_sensor: 'No Sensor',
        data_error: 'No Recent Data',
        expired: 'Sensor Expired',
        archived: 'Archived',
      },
      data_status_tooltip: {
        active: 'Recent CGM readings received.',
        waiting_sync: 'Sensor paired, waiting for first sync.',
        no_sensor: 'No CGM device linked yet — pair a sensor to start collecting data.',
        data_error:
          'No readings for over 24h — the sensor may have finished its wear, come off, or lost its phone connection.',
        expired:
          'This sensor has reached the end of its 14-day wear life. Replace it to resume monitoring.',
        archived: 'Pet record archived.',
      },
      data_status_alert: {
        no_sensor: {
          title: 'No active CGM session found for this pet.',
          body: 'This pet has no CGM device linked yet. Pair a sensor to start collecting glucose readings.',
          action: 'Pair Sensor',
        },
        waiting_sync: {
          title: 'Sensor connected, waiting for data sync.',
          body: '%{smart_count} sensor paired but no readings uploaded yet. CGM devices typically deliver the first batch within an hour of activation. |||| %{smart_count} sensors paired but no readings uploaded yet. CGM devices typically deliver the first batch within an hour of activation.',
        },
        data_error: {
          title: 'Sensor data has stalled.',
          body: 'The last reading was over 24 hours ago. Make sure the device is connected, or contact support if the issue persists.',
        },
        expired: {
          title: 'Sensor expired — replace sensor',
          body: 'This sensor has reached the end of its 14-day wear life and has stopped collecting new readings. Replace it with a new sensor to resume monitoring.',
          action: 'Replace Sensor',
        },
        archived: {
          title: 'This pet record is archived.',
          body: 'Archived pets retain historical data but no new readings are collected.',
        },
        devices_load_failed: {
          title: 'Sensor information could not be loaded.',
          body: 'Sensor and data-status details are missing until it loads, so a patient may not show the sensor they have. Reload the page to try again.',
        },
        device_data_unavailable: {
          title: 'Device data is not visible to your account right now.',
          body: "This pet has linked devices, but none of their readings are visible to your session. Reload the page; if this persists, your account's data access may need to be restored — contact support.",
        },
        load_timeout: {
          title: 'This page is taking longer than expected to load.',
          body: 'This is almost always because your browser is running an older, cached version of VetPo. Reload to get the latest version — that usually restores the charts immediately. If it keeps happening, contact support.',
          action: 'Reload VetPo',
        },
      },
      sex_options: {
        male: 'Male',
        female: 'Female',
        neutered_male: 'Neutered Male',
        spayed_female: 'Spayed Female',
        unknown: 'Unknown',
      },
      species_options: {
        dogs: 'Dog',
        cats: 'Cat',
        horses: 'Horse',
        cows: 'Cow',
        rabbits: 'Rabbit',
        guinea_pigs: 'Guinea Pig',
        ferrets: 'Ferret',
      },
      action: {
        accept: 'Accept',
        reject: 'Reject',
      },
      hide: {
        action: 'Hide from my list',
        confirm_title: 'Hide this patient from your clinic list?',
        confirm_body:
          'This removes %{pet} from your clinic’s patient list only. Their owner, and any other clinic, still sees the record normally — nothing is deleted.',
        success: '%{pet} hidden from your list.',
        undo: 'Undo',
        undo_success: 'Patient restored to your list.',
        error: 'Could not update this patient’s hidden state. Please try again.',
        show_hidden_toggle: 'Show hidden',
        hidden_chip: 'Hidden',
        unhide_action: 'Unhide',
        hidden_list_empty: 'No hidden patients.',
        hidden_list_error: 'Could not load hidden patients. Please try again.',
        hidden_list_col_pet: 'Patient',
        hidden_list_col_owner: 'Client',
        hidden_list_col_hidden_at: 'Hidden on',
        hidden_list_col_hidden_by: 'Hidden by',
        hidden_list_col_actions: 'Actions',
      },
    },
    activities: {
      name: 'Activity |||| Activities',
      amount: '1 activity |||| %{smart_count} activities',
      detail: 'Activity detail',
      fields: {
        id: 'Id',
        name: 'Name',
        owner: 'Client',
        pet: 'Pet',
        pet_id: 'Pet ID',
        type: 'Type',
        start_time: 'Start Time',
        end_time: 'End Time',
        time: 'Duration',
        duration: 'Duration',
        description: 'Description',
        created_at: 'Created At',
        updated_at: 'Updated At',
      },
      insulin: {
        label: 'Insulin',
        brand: 'Brand',
        custom_brand: 'Custom Brand',
        dosage: 'Dosage',
        units: 'units',
      },
      action: {
        accept: 'Accept',
        reject: 'Reject',
      },
    },
    devices: {
      all_devices_pet: '🔗 All Devices (This Pet)',
      devices_count: '%{smart_count} device |||| %{smart_count} devices',
      pet_id: 'Pet ID: %{id}',
      name: 'Device |||| Devices',
      amount: '1 device |||| %{smart_count} devices',
      detail: 'Device detail',
      fields: {
        id: 'Id',
        name: 'Name',
        owner: 'Client',
        pet: 'Pet',
        type: 'Type',
        start_time: 'Start Time',
        glucose_trend: 'Glucose Trend',
        timezone: 'Timezone',
        createdAt: 'Created',
        updatedAt: 'Updated',
      },
      action: {
        accept: 'Accept',
        reject: 'Reject',
      },
    },
    metrics: {
      name: 'Reading |||| Readings',
      amount: '1 reading |||| %{smart_count} readings',
      detail: 'Reading detail',
      fields: {
        id: 'Id',
        name: 'Name',
        owner: 'Client',
        device: 'Device',
        offset: 'Offset',
        timestamp: 'Timestamp',
        // This raw-data list shows the STORED (QR) value, uncorrected.
        // Labelled so a support session can't misread a stored 14.2 as the
        // 12.1 the vet sees on the chart. The display column beside it carries
        // the BGM-corrected, masked value that matches every clinical surface
        // and this list's own CSV export.
        glucose: 'Glucose (raw)',
        glucose_display: 'Glucose (display)',
        createdAt: 'Created At',
        updatedAt: 'Updated At',
      },
      action: {
        accept: 'Accept',
        reject: 'Reject',
      },
    },
    emrs: {
      name: 'Note |||| Notes',
      amount: '1 note |||| %{smart_count} notes',
      detail: 'Note detail',
      fields: {
        id: 'Id',
        pet: 'Pet',
        pet_id: 'Pet ID',
        vet: 'Vet',
        notes: 'Notes',
        number: '#',
        author: 'Author',
        content: 'Content',
        timestamp: 'Date',
        date: 'Date',
        created: 'Created',
        updated: 'Updated',
        createdAt: 'Created',
        updatedAt: 'Updated',
      },
      action: {
        accept: 'Accept',
        reject: 'Reject',
        add_note: 'Add Note',
      },
      notifications: {
        created: 'Note created |||| %{smart_count} notes created',
        updated: 'Note updated |||| %{smart_count} notes updated',
        deleted: 'Note deleted |||| %{smart_count} notes deleted',
        approved_success: 'Note approved',
        approved_error: 'Error: Note not approved',
        rejected_success: 'Note rejected',
        rejected_error: 'Error: Note not rejected',
      },
    },
    foods: {
      name: 'Food |||| Foods',
      fields: {
        brand: 'Brand',
        productName: 'Product',
        species: 'Species',
        form: 'Form',
        displayName: 'Display name',
        kcalPerGram: 'kcal/g',
        proteinPercent: 'Protein %',
        fatPercent: 'Fat %',
        carbohydratePercent: 'Carbohydrate %',
        fiberPercent: 'Fiber %',
        moisturePercent: 'Moisture %',
        glycemicIndex: 'Glycemic index',
        diabeticFriendly: 'Diabetic-friendly',
        isActive: 'Active',
        sourceUrl: 'Source URL (vendor page)',
        notes: 'Notes',
        protein: 'Protein %',
        carb: 'Carb %',
        gi: 'GI',
      },
      sections: {
        identity: 'Identity',
        energy: 'Energy density',
        macros: 'Macros (as-fed %)',
        diabetes: 'Diabetes profile',
        admin: 'Catalog administration',
      },
      helpers: {
        display_name: "Optional override — defaults to '{brand} — {productName}'",
        kcal_per_gram: 'kcal per gram of food as fed',
        kcal_per_gram_detail: 'kcal per gram of food as fed (typical dry: 3.5-4.5; wet: 0.8-1.2)',
        glycemic_index: 'Estimated GI on 0-100 scale (lower is better for diabetics)',
        diabetic_friendly: 'Low-GI, low-carb, vet-recommended for diabetic pets',
      },
      species: {
        dog: 'Dog',
        cat: 'Cat',
        both: 'Both',
        dog_and_cat: 'Dog + Cat',
      },
      form: {
        dry: 'Dry',
        wet: 'Wet',
        treat: 'Treat',
        topper: 'Topper',
        raw: 'Raw',
        other: 'Other',
      },
    },
    glucose: {
      axis_labels: {
        max: 'Max',
        min: 'Min',
        glucose: 'Glucose',
        date: 'Date',
        time: 'Time',
      },
      hover_labels: {
        max: 'Max',
        min: 'Min',
      },
    },
    segments: {
      name: 'Segment |||| Segments',
      fields: {
        customers: 'Clients',
        name: 'Group Name',
      },
      data: {
        compulsive: 'Compulsive',
        collector: 'Collector',
        ordered_once: 'Ordered once',
        regular: 'Regular',
        returns: 'Returns',
        reviewer: 'Reviewer',
      },
    },
  },
}

export default customEnglishMessages
